import { AppData } from "../../../types";

export type HideNonModalDialogOptions = {
  appData: AppData;
};

export function hideNonModalDialog({
  appData,
}: HideNonModalDialogOptions): AppData {
  const newAppData = { ...appData };
  delete newAppData.nonModalDialog;
  return newAppData;
}
